import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Alert,
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Avatar,
} from '@mui/material';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState(''); // Keep if needed
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState('');
  const [sessionMessage, setSessionMessage] = useState('');

  useEffect(() => {
    document.title = 'Login | Velora Money';
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const reason = params.get('reason');
    if (!reason) return;

    setSessionMessage('Session expired. Please sign in again.');
    params.delete('reason');
    const nextSearch = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
      },
      { replace: true }
    );
  }, [location.pathname, location.search, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const user = await login(email, password);
      navigate(user.role === 'super admin' ? '/admin' : '/dashboard', { replace: true });
    } catch (err: any) {
      console.error('Login failed:', err);
      setError(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9f9f9',
      }}
    >
      <Paper elevation={3} sx={{ padding: 5, width: 400, textAlign: 'center' }}>
        <Avatar
          sx={{
            width: 245,
            height: 100,
            backgroundColor: 'transparent',
            margin: '0 auto',
          }}
        >
          <img src="/assets/img/logo.png" alt="Velora logo" style={{ width: '100%' }} />
        </Avatar>


        <Typography variant="h6" mt={1}>
          Welcome
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          Sign in to manage your finances with Velora
        </Typography>

        {sessionMessage ? (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {sessionMessage}
          </Alert>
        ) : null}

        <form onSubmit={handleSubmit}>
          <TextField
            label="Email address"
            type="email"
            variant="outlined"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            sx={{ mb: 2 }}
          />

          <TextField
            label="Password"
            type="password"
            variant="outlined"
            fullWidth
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={{ mb: 2 }}
          /> 

          <Button
            type="submit"
            variant="contained"
            fullWidth
            sx={{ backgroundColor: '#3f51b5', color: '#fff', py: 1.3 }}
          >
            Continue
          </Button>
        </form>

        {error && (
          <Typography color="error" mt={2}>
            {error}
          </Typography>
        )}
      </Paper>
    </Box>
  );
};

export default Login;
